import { Navigate } from 'react-router-dom';

import { useOrganisationId, useVirtualAccounts } from 'hooks/context';

import { Loading } from 'components/pages/Loading';

export const AccountsRedirection = () => {
  const organisationId = useOrganisationId();

  const { accounts, isLoading } = useVirtualAccounts();

  if (isLoading) return <Loading text="Loading accounts" />;
  const defaultAccount = accounts[0]?.account_number;

  if (!defaultAccount) return <Navigate to={`/org/${organisationId}`} />;

  return <Navigate to={`/org/${organisationId}/accounts/${defaultAccount}`} />;
};
